export function getIsDesktopEpgPresent() {
  return Boolean(document.querySelector('#epgModule #MainContainer'));
}
